import { render } from "./OptOutForm.vue?vue&type=template&id=676a3a71"
import script from "./OptOutForm.vue?vue&type=script&lang=js"
export * from "./OptOutForm.vue?vue&type=script&lang=js"

import "./OptOutForm.vue?vue&type=style&index=0&id=676a3a71&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__